import { Pool } from '~/pages/CrossChainFarmPage'
import { CROSSCHAIN_CONFIG } from '~/lib/config'
import { symbiosis } from '~/lib/symbiosis'

export function getPools(): Pool[] {
	const enabledChains = CROSSCHAIN_CONFIG.chains.all.filter((chainConfig) =>
		CROSSCHAIN_CONFIG.chains.enabled.includes(chainConfig.id)
	)

	const pools: Pool[] = []

	enabledChains.forEach((chain) => {
		chain.nerves.forEach((nerve) => {
			const tokenA = symbiosis.findStable(nerve.tokens[0], chain.id)
			const tokenB = symbiosis.findStable(nerve.tokens[1], chain.id)

			if (!tokenA || !tokenB) {
				console.error('Did not find nerve', nerve)
				return
			}

			pools.push({
				address: nerve.address,
				id: `${tokenA?.symbol} / ${tokenB?.symbol}`,
				tokenA,
				tokenB,
			})
		})
	})

	return pools
}
